export default "__VITE_ASSET__DaBamuc6__"